import React from 'react';
import PropTypes from 'prop-types';
import { string } from 'yup';
import BaseInput from '../base';

const Street = props => {
  const { 'data-cv-test': dataCvTest, type } = props;

  return (
    <BaseInput
      name="street"
      label="Address, Line 1"
      type="text"
      inputTip={
        type === 'home'
          ? 'This will also be your vehicle registration address'
          : ''
      }
      transparent
      validate={val =>
        string()
          .required('Enter a street name')
          .min(5, 'Address must be greater than 5 characters')
          .max(100, 'Address cannot be greater than 100 characters')
          .validate(val)
          .then(() => null)
          .catch(err => err.errors.join(', '))
      }
      {...props}
      data-cv-test-override={dataCvTest || 'addressStreetLineOne'}
    />
  );
};

Street.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  error: PropTypes.string,
  'data-cv-test': PropTypes.string,
  type: PropTypes.string
};

Street.defaultProps = {
  value: '',
  error: '',
  'data-cv-test': '',
  type: ''
};

export default Street;
